import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class ProductAttributesEditValidator {

    attribute = [
        Validators.required
    ];
    attribute_value = [
        Validators.required
    ];
  
    // Error messages
    errorMessages = {
        
        attribute: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        attribute_value: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}